import { type FC, type HTMLAttributes, type ReactElement } from 'react';

import { TCell, type TCellProps } from '../tcell';
import { TRow } from '../trow/trow';
import styles from './trow-expandable-outside.module.scss';

type TCellElement = ReactElement<TCellProps, typeof TCell>;

export type TRowExpandableOutsideProps = HTMLAttributes<HTMLTableRowElement> & {
  children: TCellElement | TCellElement[];
  isExpanded?: boolean;
  hasHover?: boolean;
  contentReactNode: TCellElement | TCellElement[];
  onSelectRow?: () => void;
};

export const TRowExpandableOutside: FC<TRowExpandableOutsideProps> = ({
  contentReactNode,
  isExpanded,
  onSelectRow,
  ...props
}) => {
  return (
    <>
      <TRow className={styles.row} {...props} />
      {isExpanded && contentReactNode}
    </>
  );
};
